export default "__VITE_ASSET__ba581684__"